import { PublicFooter } from "@/components/public-footer"
import { PublicHeader } from "@/components/public-header"
import { SEO } from "@/components/seo"

export default function Terms() {
  return (
    <>
      <SEO
        title="Terms of Service - StitchPDF"
        description="StitchPDF terms of service. Understand your rights and responsibilities when using our free online PDF tools. Fair, simple terms for all users."
        canonical="https://stitchpdf.com/terms"
        ogDescription="Terms of service for StitchPDF online PDF tools."
      />

      <div className="bg-background flex min-h-screen flex-col">
        <PublicHeader />

        <main className="container mx-auto flex-1 px-4 py-16">
          <div className="prose dark:prose-invert mx-auto max-w-3xl">
            <h1>Terms of Service</h1>
            <p className="lead">Last updated: February 28, 2026</p>

            <h2>1. Service Provider</h2>
            <p>
              StitchPDF is operated by Gorg Rails Tech Solutions, Limitada,
              established in Portugal.
            </p>
            <p>These Terms are governed by the laws of Portugal.</p>

            <h2>2. Service Description</h2>
            <p>
              StitchPDF provides browser-based PDF tools including merging,
              splitting, reordering, protecting, signing, and converting images
              to PDF.
            </p>

            <h2>3. Account Registration</h2>
            <p>You must be at least 13 years old to use StitchPDF.</p>
            <p>
              You are responsible for maintaining the confidentiality of your
              account credentials and for all activities under your account.
            </p>

            <h2>4. Acceptable Use</h2>
            <p>You agree to use StitchPDF only for lawful purposes.</p>
            <p>
              You may not upload or process content that is illegal, harmful, or
              infringes on the rights of others.
            </p>
            <p>
              We do not review user files and are not responsible for user
              content.
            </p>

            <h2>5. Your Content</h2>
            <p>You retain all rights to your files.</p>
            <p>We do not claim ownership of your content.</p>
            <p>
              You grant us a limited license to process your files solely for
              the purpose of providing the service.
            </p>

            <h2>6. Payments and Subscriptions</h2>
            <p>Paid subscriptions are billed through Stripe.</p>
            <p>
              Subscriptions are available on a monthly or annual basis and renew
              automatically unless canceled before the renewal date.
            </p>
            <p>You may cancel at any time from your account settings.</p>
            <p>Refunds are handled on a case-by-case basis.</p>

            <h2>7. Service Availability</h2>
            <p>
              StitchPDF is provided &ldquo;as is&rdquo; without warranties of
              any kind.
            </p>
            <p>
              We strive for high availability but do not guarantee uninterrupted
              or error-free service.
            </p>

            <h2>8. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, StitchPDF is not liable
              for indirect, incidental, or consequential damages arising from
              use of the service, including data loss or service interruptions.
            </p>

            <h2>9. Account Termination</h2>
            <p>
              We may suspend or terminate accounts that violate these Terms or
              engage in abusive behavior.
            </p>

            <h2>10. Intellectual Property</h2>
            <p>
              StitchPDF and its logo are trademarks of Gorg Rails Tech
              Solutions, Limitada.
            </p>
            <p>The service, design, and code are our intellectual property.</p>
            <p>Your use of the service does not grant any ownership rights.</p>

            <h2>11. Changes to Terms</h2>
            <p>
              We may update these Terms from time to time. Continued use of the
              service after changes constitutes acceptance of the updated Terms.
            </p>
          </div>
        </main>

        <PublicFooter />
      </div>
    </>
  )
}
